import { render, staticRenderFns } from "./FormValidateEmail.vue?vue&type=template&id=00701c4b"
import script from "./FormValidateEmail.vue?vue&type=script&lang=js"
export * from "./FormValidateEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports